import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import { getRelativePath } from "Utils";
export default store => ({
  path: ":student_id(/:orientation)",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "transcript-chunk" */ "ProgressReport/routes/ProgressReportDetails/routes/StudentProgressReport/components"
        ),
        import(
          /* webpackChunkName: "transcript-chunk" */ "ProgressReport/modules/ProgressReportModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const progressReportReducer = importedModule1.default;
        injectReducer(store, {
          key: "progressReport",
          reducer: progressReportReducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter: (nextState, replace) => {
    const pathname = _.get(nextState, "location.pathname", "");
    if (
      !_.includes(pathname, "portrait") &&
      !_.includes(pathname, "landscape")
    ) {
      replace(getRelativePath(`./portrait`));
    }
  },
  childRoutes: [],
});
